import { useEffect, useState } from "react";
import axios from "axios";
import { Flame } from "lucide-react";
import { resolveImageUrl, PLACEHOLDER } from "@/utils/imageUrl";
import { getProductSizes } from "@/utils/whatsapp";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SoldCard = ({ product }) => {
  const img = product.image_url ? resolveImageUrl(product.image_url) : product.images?.[0] ? resolveImageUrl(product.images[0]) : PLACEHOLDER;
  const sizes = getProductSizes(product);
  return (
    <div className="product-card opacity-60 saturate-0 hover:opacity-80 transition-opacity" data-testid={`sold-card-${product.id}`}>
      <div className="relative aspect-[3/4] bg-[#0a0a0a] overflow-hidden rounded-t-2xl">
        <img src={img} alt={product.name} loading="lazy" onError={(e) => { e.target.src = PLACEHOLDER; }} className="w-full h-full object-cover grayscale" />
        <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
          <span className="border-2 border-white text-white font-oswald text-2xl font-bold uppercase tracking-widest px-4 py-1.5 -rotate-12 bg-black/50" data-testid={`sold-badge-${product.id}`}>
            Vendido
          </span>
        </div>
      </div>
      <div className="p-4">
        {product.brand && <p className="text-xs text-[#A0A0A0] uppercase tracking-wider mb-1 font-semibold">{product.brand}</p>}
        <h3 className="font-medium text-sm text-white/80 line-clamp-2 min-h-[2.5rem]">{product.name}</h3>
        {sizes.length > 0 && <p className="text-xs text-[#A0A0A0] mt-1">Talla {sizes.join(", ")}</p>}
      </div>
    </div>
  );
};

export const RecentlySold = ({ category }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const params = category ? `?category=${encodeURIComponent(category)}&limit=8` : "?limit=8";
    axios.get(`${API}/products/sold/recent${params}`).then(res => setItems(res.data)).catch(() => setItems([]));
  }, [category]);

  if (items.length === 0) return null;

  return (
    <section className="py-12 px-4 border-t border-white/5" data-testid="recently-sold-section">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <span className="inline-flex items-center gap-2 bg-white/5 text-[#A0A0A0] text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wider mb-3">
            <Flame className="w-3.5 h-3.5 text-orange-400" /> Se van rapido
          </span>
          <h2 className="font-oswald text-2xl sm:text-3xl font-bold text-white uppercase tracking-wider">Vendidos Recientemente</h2>
          <p className="text-[#A0A0A0] text-base mt-1">Estas piezas ya encontraron dueno. No te quedes sin la tuya.</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {items.map(p => <SoldCard key={p.id} product={p} />)}
        </div>
      </div>
    </section>
  );
};
